import {html, css, LitElement} from 'lit';
import Fuse from 'fuse';


function toSorted(arr, func) {
    return [...arr].sort(func)
}

export class DzSuperlist extends LitElement {

    static properties = {
        keys:           {type: String},
        placeholder:    {type: String},
        searchkey:      {type: String},
        sortkey:        {type: String},
        datakey:        {type: String},
        limit:          {type: Number},
        message:        {type: String}
    };

    connectedCallback() {
        super.connectedCallback()
        this.page       = 0    
        this.items      = JSON.parse(this.children[0].textContent)
        this.filtered   = toSorted(this.items, (a, b) => a[this.sortkey] > b[this.sortkey] ? -1 : 1)  

        let searchdata  = this.items.map((x) => x[this.searchkey])
        this.fuse       = new Fuse(searchdata, {threshold: 0, minMatchCharLength: 2})   
    }

    render() {
        let result = []
        let singular = this.items.length == 1
        if (this.filtered.length > this.limit) {
            result.push(html`
                <div part="panel">
                    <input part="input" type="text" @input="${this.filterContent}">
                    
                    <div part="icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.13644 0.240234C6.49094 0.240234 7.78996 0.778307 8.74774 1.73608C9.70551 2.69386 10.2436 3.99288 10.2436 5.34738C10.2436 6.61238 9.78001 7.77523 9.01787 8.67095L9.23001 8.88309H9.85073L13.7793 12.8117L12.6007 13.9902L8.67215 10.0617V9.44095L8.46001 9.22881C7.5643 9.99095 6.40144 10.4545 5.13644 10.4545C3.78194 10.4545 2.48292 9.91645 1.52514 8.95867C0.567369 8.0009 0.0292969 6.70188 0.0292969 5.34738C0.0292969 3.99288 0.567369 2.69386 1.52514 1.73608C2.48292 0.778307 3.78194 0.240234 5.13644 0.240234ZM5.13644 1.81166C3.17215 1.81166 1.60073 3.38309 1.60073 5.34738C1.60073 7.31166 3.17215 8.88309 5.13644 8.88309C7.10073 8.88309 8.67215 7.31166 8.67215 5.34738C8.67215 3.38309 7.10073 1.81166 5.13644 1.81166Z" fill="black"/>
                        </svg>
                    </div>
                </div>
                `)
        } 
        
        let list    = []
        for (let item of this.filtered) {
            let keys = []
            if (!singular) {
                keys.push(html`<input part="checkbox" type="checkbox" .checked=${item.selected} @click="${() => this.chooseItem(item)}">`)
            } else {
                keys.push(html`<div></div>`)
            }
            for (let key of this.keys.split(",").map(k => k.trim())) {
                keys.push(html`<span>${item[key]}</span>`)
            }
            list.push(html`<div part="item${item.marked ? "-marked": ""}" style="${this.filtered.length <= this.limit+2 ? "margin-right: 8px !important" : ""}">${keys}</div>`)
        }

        result.push(html`<div part="items" style="${this.filtered.length <= this.limit ? "height:auto !important" : ""}">${list}</div>`)
        if (!singular) {
            result.push(html`
                <div part="buttons">
                    <button part="button" @click="${this.submit}" style="${this.filtered.length < this.limit ? "margin-right:10px !important" : ""}">${this.message}</button>
                </div>
            `)
        }
        return html`${result}`
    }

    updated() {
        let marked = this.renderRoot.querySelector("*[part=item-marked]")
        if (marked) {
            let items = marked.parentElement
            items.scrollTo({
                top: 0,
                behavior: "instant"
            })
        }
    }


    reset() {
        for (let item of this.items) {
            item.selected = false
        }
        let evt = new CustomEvent('reset', { bubbles: true, composed: true, detail: null });
        this.dispatchEvent(evt);
    }


    submit() {
        let selected = this.items.filter(x => x.selected).map(x => x[this.searchkey])
        let evt = new CustomEvent('submit', { bubbles: true, composed: true, detail: selected });
        this.dispatchEvent(evt);
    }


    filterContent(evt) {
        this.items.forEach(x => x.marked = false )
        if (evt.target.value == "") {
            this.filtered = toSorted(this.items, (a, b) => a[this.sortkey] > b[this.sortkey] ? -1 : 1)
        } else {
            let result = this.fuse.search(evt.target.value)
            let tail   = [...this.items]
            let head   = []
            for (let r of result) {
                let x = tail.splice(r.refIndex, 1)[0]
                x.marked = true
                head.push(x)
            }
            this.filtered = head.concat(toSorted(tail, (a, b) => a[this.sortkey] > b[this.sortkey] ? -1 : 1))
        }
        this.page = 0
        this.requestUpdate()
    }

    chooseItem(item) {
        if (item.selected) {
            item.selected = false
        } else {
            item.selected = true
        }
        this.requestUpdate()
    }   

    static get styles() {
        return css`
            *[part=panel] {
                padding-right: 18px;
            }
            
            *[part=items] {
                scrollbar-color: auto;
                scrollbar-width: thin;
                padding-right: 10px;
            }

            *[part=checkbox]:checked {
                outline: solid grey 4px;
                outline-offset: -10px;
            }

            *[part=items]::-webkit-scrollbar-thumb {
                border-radius: 20px
            }

            *[part=items]::-webkit-scrollbar {
                width: 8px;
            }

            *[part=items]::-webkit-scrollbar-thumb {
                margin: 3px;
                background: #eee;
                border-radius: 20px;
            }

            *[part=item] span:last-child {
                text-align: center;
            }

            *[part=items]::-webkit-scrollbar-thumb:hover {
                background: rgb(209, 209, 209);
            }
        `
      }

}
customElements.define('dz-superlist', DzSuperlist);